import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

import kaizenLogo from "../../assets/images/kaizenLogoo.png";
import wordmark from "../../assets/images/obsessed.png";

const SplashScreen = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 1100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <Container
          as={motion.div}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* preload fontova koje sajt koristi */}
          <FontPreload style={{ fontFamily: "Poppins-Regular" }}>.</FontPreload>
          <FontPreload style={{ fontFamily: "Poppins-Medium" }}>.</FontPreload>
          <FontPreload style={{ fontFamily: "Poppins-SemiBold" }}>
            .
          </FontPreload>
          <FontPreload style={{ fontFamily: "Poppins-Bold" }}>.</FontPreload>

          <LogoRow>
            <KaizenImg
              src={kaizenLogo}
              alt=""
              as={motion.img}
              initial={{ opacity: 0, scale: 1.5, rotate: -8 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              transition={{ duration: 0.55, ease: [0.22, 0.72, 0.18, 1] }}
            />
            <Wordmark
              src={wordmark}
              alt="OBSESSED"
              as={motion.img}
              initial={{ clipPath: "inset(0 100% 0 0)", opacity: 1, x: -14 }}
              animate={{ clipPath: "inset(0 0% 0 0)", x: 0 }}
              transition={{
                delay: 0.25,
                duration: 0.6,
                ease: [0.22, 0.72, 0.18, 1],
              }}
            />
          </LogoRow>

          <LineTrack>
            <Line />
          </LineTrack>
        </Container>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;

const fill = keyframes`
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
`;

const Container = styled.div`
  position: fixed;
  inset: 0;
  background: var(--bg0, #0a0a0c);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.8rem;
  pointer-events: none;
  z-index: 9999;
`;

const FontPreload = styled.span`
  position: absolute;
  opacity: 0;
  font-size: 0.1px;
  color: transparent;
  user-select: none;
  pointer-events: none;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4rem;
  user-select: none;
`;

const KaizenImg = styled.img`
  height: clamp(4.2rem, 7vw, 6rem);
  width: auto;

  @media (max-width: 390px) {
    height: 3.6rem;
  }
`;

const Wordmark = styled.img`
  width: clamp(24rem, 42vw, 36rem);
  height: auto;

  @media (max-width: 390px) {
    width: 22rem;
  }
`;

const LineTrack = styled.div`
  width: min(26rem, 60vw);
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10rem;
  overflow: hidden;
  margin-top: 1rem;
`;

const Line = styled.div`
  height: 100%;
  width: 100%;
  background: var(--red, #fe5f55);
  transform-origin: left;
  animation: ${fill} 0.95s ease-out forwards;
`;
